<template>
    <div class="introduction ">
        <!-- <div class="way">
            <el-row type="flex"
                    class="row-bg"
                    justify="center">
                <el-col :span="20">
                    <breadcrumb></breadcrumb>
                </el-col>
            </el-row>
        </div> -->
        <div class="main">
            <el-row type="flex"
                    class="row-bg"
                    justify="center">
                <el-col :span="20">
                    <div class="btn"
                         :style="{width:overwidth}"
                         v-for="(item,index) in brotherMenu"
                         :key="index"
                         @click="assign(item)"
                         :class="{active: activeIndex === item.id}">
                        <p class="line">{{item.name}}</p>
                    </div>
                </el-col>
            </el-row>
        </div>
        <keep-alive>
            <component :is="currentpage"></component>
        </keep-alive>
    </div>
</template>

<script>
// import Bus from "@/utils/bus";
import chronicle from "@/views/summary/chronicle";
import culture from "@/views/summary/culture";
import synopsis from "@/views/summary/synopsis";
import honor from "@/views/summary/honor";
import breadcrumb from "@/components/breadcrumb";
import { mapGetters } from "vuex";
export default {
    components: {
        chronicle,
        culture,
        synopsis,
        honor,
        breadcrumb
    },
    computed: {
        ...mapGetters(["activeIndex", "parentList", "brotherMenu"])
    },
    data() {
        return {
            position: "",
            overwidth: "25%",
            currentpage: "synopsis",
            list: [
                { name: "synopsis", title: "壹米滴答简介" },
                { name: "chronicle", title: "发展历程" },
                { name: "culture", title: "品牌&文化" },
                { name: "honor", title: "企业荣誉" }
            ]
        };
    },
    watch: {
        //监听路由变化
        $route(to, from) {
            this.currentpage = this.$route.params.id;
        }
    },
    created() {
        // this.search();
        this.currentpage = this.$route.params.id;
    },
    mounted() {
        if (sessionStorage.getItem("activeIndex")) {
            this.$store.dispatch(
                "BannerPath",
                sessionStorage.getItem("activeIndex")
            );
            //this.getInitBanner(sessionStorage.getItem("activeIndex")); "/proddetails/transportation"
        }
    },
    methods: {
        assign(item) {
            this.$router.push({
                path: item.demoFlag,
                query: {
                    id: item.id
                }
            });
            this.$store.dispatch("BannerPath", item.id);
            // this.$store.dispatch("UpdateActive", item);
            this.$store.dispatch("ContentDesc", item.id);
        }
    }
};
</script>

<style scoped lang="scss">
.introduction {
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #221814;
        .el-breadcrumb {
            line-height: 50px;
        }
    }
    .main {
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        .btn {
            cursor: pointer;
            height: 54px;
            margin: 0 auto;
            display: inline-block;
            text-align: center;
            font-size: 20px;
            line-height: 54px;
        }
    }
    .active {
        border-bottom: 2px solid #fabe00;
    }
}
</style>
